import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { MarkdownEditor } from "@/components/ui/markdown-editor";

interface MedicalTextInputProps {
  text: string;
  notes: string;
  onTextChange: (text: string) => void;
  onNotesChange: (notes: string) => void;
  medicalTextId?: string;
  isFullScreen?: boolean;
}

export function MedicalTextInput({
  text,
  notes,
  onTextChange,
  onNotesChange,
  medicalTextId,
  isFullScreen = false,
}: MedicalTextInputProps) {
  return (
    <>
      <div className={`space-y-2 w-full ${isFullScreen ? "p-4 border rounded-lg bg-muted/30" : ""}`}>
        <MarkdownEditor
          value={text}
          onChange={onTextChange}
          placeholder="Enter medical text (1000-2000 characters). You can use markdown formatting like **bold**, *italic*, lists, etc."
          label="Medical Text"
          isFullScreen={isFullScreen}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="notes">
          Notes
          {medicalTextId && <span className="text-sm text-gray-500 ml-2">(autosaves)</span>}
        </Label>
        <Textarea
          id="notes"
          value={notes}
          onChange={(e) => onNotesChange(e.target.value)}
          placeholder="Add any additional notes about this medical text..."
          className={`transition-all duration-300 ${isFullScreen ? "min-h-[120px]" : "min-h-[80px]"}`}
        />
      </div>
    </>
  );
}
